import { TERMS_NOTICE } from "../copy/termsNotice";

export function TermsContent(): JSX.Element {
  return <div className="terms-detail__body">
    <h2>{TERMS_NOTICE.title}</h2>
    <p className="terms-detail__updated">Last updated: {TERMS_NOTICE.lastUpdated}</p>
    {TERMS_NOTICE.intro.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
    {TERMS_NOTICE.sections.map((section, sectionIndex) => <section className="terms-detail__section" key={section.title}>
      <h3>{sectionIndex + 1}. {section.title}</h3>
      {section.blocks.map((block, index) => block.kind === "paragraph" ? <p key={index}>{block.text}</p> :
        <ul key={index}>{block.items.map((item) => <li key={item}>{item}</li>)}</ul>)}
    </section>)}
    <p><a href={`mailto:${TERMS_NOTICE.contactEmail}`}>{TERMS_NOTICE.contactEmail}</a></p>
  </div>;
}
